﻿import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";
import { DialogService } from "@app/services/dialog.service";

@NgComponent({
    token: Token.KbMediaList,
    dependencies: [
        Token.$RootScope,
        Token.DialogService,
    ]
})
export class KbMediaList extends Directive {
    constructor(
        private $rootScope: IRootScope,
        private dialogService: DialogService
    ) {
        super();

        this.replace = true;
        // this.require = 'ngModel';
        this.template = Dirs.component("kb-media-list");
        this.restrict = "E";
        this.scope = {
            ngModel: "=",
            addItem: "&",
            imagePath: "@"
        };

        this.link = (scope: any, element, atts: any) => {
            scope.isEnabled = () => {
                return !($(element).hasClass("disabled") || $(element).attr("disabled"));
            };

            scope.deleteItem = (index: number) => {
                scope.ngModel.splice(index, 1);
            };
        };
    }

}
